import {describeApiOutcome, responseOf, statusOf, wasSuccessful} from '@/utils/apiOutcome';

const CLOUD_FUNCTION_FAILED_FALLBACK = 'De portaalbewerking is niet gelukt.';

const FIREBASE_AUTH_CODE_PREFIX = 'auth/';

function cloudFunctionBody(result) {
    const response = responseOf(result);

    return (response && response.data) || {};
}

export function cloudFunctionError(result) {
    const data = cloudFunctionBody(result);

    if (typeof data.code === 'string') {
        return data.code;
    }

    if (data.errorInfo && typeof data.errorInfo.code === 'string') {
        return data.errorInfo.code;
    }

    return null;
}

export function cloudFunctionErrorMessage(result) {
    const data = cloudFunctionBody(result);

    if (data.errorInfo && typeof data.errorInfo.message === 'string') {
        return data.errorInfo.message.trim();
    }

    return '';
}

export function isFirebaseAuthRefusal(result) {
    const error = cloudFunctionError(result);

    return wasSuccessful(statusOf(result))
        && typeof error === 'string'
        && error.indexOf(FIREBASE_AUTH_CODE_PREFIX) === 0;
}

export function describeCloudFunctionOutcome(result) {
    const outcome = describeApiOutcome(result, {fallback: CLOUD_FUNCTION_FAILED_FALLBACK});
    const error = cloudFunctionError(result);
    const isErrorEmbeddedInASuccessfulResponse = outcome.ok && error !== null;

    if (!isErrorEmbeddedInASuccessfulResponse) {
        return {...outcome, error};
    }

    return {
        ok: false,
        status: outcome.status,
        fieldError: null,
        message: cloudFunctionErrorMessage(result) || CLOUD_FUNCTION_FAILED_FALLBACK,
        data: null,
        error,
    };
}
